import Button from '@space-core/components/button'
import Icon from '@space-core/components/icon'
import { CustomIcon } from '@space-shell/modules/communities/communityConfigurationSidebar/styles'
import styled from 'styled-components'

export const ButtonCloseModal = styled(Button)`
  height: min-content;
  margin-top: 0.4rem;
`

ButtonCloseModal.displayName = 'ButtonCloseModal'

export const ModalDescription = styled.p`
  font-size: 0.875rem;
`

ModalDescription.displayName = 'ModalDescription'

export const ArrowIcon = styled(Icon)`
  width: 0.75rem;
  height: 0.75rem;
`

ArrowIcon.displayName = 'ArrowIcon'

export const KeepMembersLabel = styled.p`
  font-weight: 600;
`

KeepMembersLabel.displayName = 'KeepMembersLabel'

export const WarningAlert = styled.div`
  background-color: var(--yellow-lightest);
`

WarningAlert.displayName = 'WarningAlert'

export const WarningLabel = styled.p`
  color: var(--yellow-darker);
`

WarningLabel.displayName = 'WarningLabel'

export const WarningIcon = styled(CustomIcon)`
  color: var(--yellow-darkest);
  width: 1rem;
  height: 1rem;
`

WarningIcon.displayName = 'WarningIcon'
